const Gender = {
  MALE: { id: 0, name: 'Masculino' },
  FEMALE: { id: 1, name: 'Feminino' }
}

Object.freeze(Gender)

export default Gender